export const FUNNEL_RECAP_TEST_ID = 'funnel-recap';
export const FUNNEL_NAVIGATION_LEFT_BUTTON = 'funnel-navigation-left-button';
export const FUNNEL_NAVIGATION_RIGHT_BUTTON = 'funnel-navigation-right-button';
